var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c' +
      (_vm.campo.cmp_tipo == 'componente' ||
      (_vm.campo.cmp_tipo == 'join' && _vm.campo.componente) ||
      (_vm.campo.cmp_tipo == 'manual' && _vm.campo.componente)
        ? 'c-' + _vm.campo.componente
        : _vm.campo.cmp_tipo),{tag:"component",attrs:{"value":_vm.value,"campo":_vm.campo,"crud":_vm.crud,"row":_vm.row,"modo":_vm.modo || _vm.tiposhow},on:{"input":event => _vm.$emit('input', event)}})
}
var staticRenderFns = []

export { render, staticRenderFns }